module.exports = __webpack_public_path__ + "83fa21ad40c20e3f16dcc34331611cd1.png";